// extracted by mini-css-extract-plugin
module.exports = {"row":"_6101fb7","unsupported":"_a51d0e3"};